import React from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { getSeoFooterData } from '../../../utils/plpMetaInfo';
import Icon from '../../../refresh/atoms/Icon';
import Text from '../../../refresh/atoms/Text';

const getTopProductWithPrice = (topProduct = []) => {
  return topProduct.map(item => (
    <a href={item.productUrl}>
      <div className="productName">{item.productName}</div>
      <div className="productPrice">
        Rs.
        {item.listPrice}
      </div>
    </a>
  ));
};

const getPlpTopBrandsBrickDom = (plpTopBrands = []) => {
  return plpTopBrands.map((item, index) => (
    <>
      <a href={item.brandUrl || item.brickUrl}>
        <span className="brandName">{item.brandName || item.brickName}</span>
      </a>
      <span>
        &nbsp;
        {index !== plpTopBrands.length - 1 ? '/' : ''}{' '}
      </span>
    </>
  ));
};

const FooterForSEOMsiteNew = ({ metaElementData = [], isFooterOpen = false, ...rest }) => {
  const topBrands = getSeoFooterData(metaElementData, 'brands');
  const topSearches = getSeoFooterData(metaElementData, 'searches');
  const bottomDescrip = getSeoFooterData(metaElementData, 'bottomDesc');

  const { plpTopBrands = [], plpTopBricks = [], plpTopProducts = [], topProductHeader = '' } = rest;

  if (
    _isEmpty(plpTopBrands) &&
    _isEmpty(topSearches) &&
    _isEmpty(bottomDescrip) &&
    _isEmpty(plpTopBricks) &&
    _isEmpty(plpTopProducts)
  ) {
    return null;
  }

  const classForContent = isFooterOpen ? 'ftr-align-center' : 'ftr-align-center close-seo';
  const iconChevron = isFooterOpen ? 'icon-Chevron-Up' : 'icon-Chevron-Down';
  const currentDate = new Date();
  const finalDate = `${currentDate.toLocaleDateString(undefined, {
    month: 'short'
  })} ${currentDate.toLocaleDateString(undefined, {
    day: '2-digit'
  })}, ${currentDate.toLocaleDateString(undefined, { year: 'numeric' })}`;

  return (
    <div
      data-ga-event-category="Page Interaction"
      data-ga-event-action="buttonTap"
      data-ga-event-label="topStores"
      className="ftr-seo-msite ftr-more-align"
    >
      <div className="category-seo-footer" role="presentation" onClick={rest.clickHandler}>
        <Text variant="T3" weight="bold">
          More Stories
        </Text>
        <Icon ariaLabel='chevron' icon={iconChevron} styles={{ fontSize: '16px', fontWeight: 'normal' }} />
      </div>

      <div id="seo-footer-content" className={classForContent}>
        <div className="msite-footer-content">
          {/* {!_isEmpty(topBrands) && <div dangerouslySetInnerHTML={{ __html: topBrands }}></div>} */}
          {!_isEmpty(plpTopBrands) && (
            <div className="plpTopBrandsBrick">
              <h2>TOP BRANDS</h2>
              {getPlpTopBrandsBrickDom(plpTopBrands)}
            </div>
          )}
          {!_isEmpty(plpTopBricks) && (
            <div className="plpTopBrandsBrick">
              <h2>TOP CATEGORIES</h2>
              {getPlpTopBrandsBrickDom(plpTopBricks)}
            </div>
          )}
          {!_isEmpty(topSearches) && !Array.isArray(topSearches) && (
            <div dangerouslySetInnerHTML={{ __html: topSearches }} />
          )}
          {!_isEmpty(bottomDescrip) && <div dangerouslySetInnerHTML={{ __html: bottomDescrip }} />}
          {plpTopProducts.length ? (
            <div className="topProduct">
              <h1>{`${topProductHeader} PRICE LIST`}</h1>
              <div className="productHeader">
                <div className="productNameHeader">{topProductHeader}</div>
                <div className="productPriceHeader">Price (Rs.)</div>
              </div>
              <div className="productData">{getTopProductWithPrice(plpTopProducts)}</div>
              <div className="lastUpdateProduct">{`Last updated on ${finalDate}`}</div>
            </div>
          ) : null}
          <div className="seo-ftr-btm-brdr" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { productsAdditionalInfo = {} } = state;
  const {
    metaElementData = [],
    topBrands = [],
    topBricks = [],
    topProducts = [],
    categoryforheader = '',
    categoryName = ''
  } = productsAdditionalInfo;
  const topProductHeader = `${categoryforheader.charAt(0).toUpperCase() +
    categoryforheader.slice(1).toLowerCase()} ${categoryName}`;
  return {
    metaElementData,
    plpTopBrands: topBrands,
    plpTopBricks: topBricks,
    plpTopProducts: topProducts,
    topProductHeader
  };
};

export default connect(mapStateToProps)(FooterForSEOMsiteNew);
